<template>
  <span :class="$style['vertical-box-align']">
    <input
      type="radio"
      :name="name"
      :class="inputClasses"
      :value="value"
      :checked="state"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="listeners"
      @change="onChange"
    >

    <slot name="box">
      <span :class="boxClasses.box">
        <span
          class="min-w-full min-h-full w-full h-full"
          :class="boxClasses.circle"
        />
      </span>
    </slot>
  </span>
</template>

<script>
import _ from 'lodash'

import CheckControl from '@c/base/mixins/CheckControl'

export default {
  mixins: [CheckControl],

  props: {
    boxClass: {
      type: Array,
      default: () => [
        'text-white',
        'overflow-hidden',
        'm-0',
        'rounded',
        'p-0',
        'bg-white',
        'border'
      ]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    state () {
      if (this.modelValue === undefined) {
        return this.checked
      }

      return _.isEqual(this.modelValue, this.value)
    },

    inputClasses () {
      return ['absolute', 'appearance-none', 'opacity-0', this.$style['box-size'], {
        'cursor-pointer': !this.disabled
      }]
    },

    boxClasses () {
      return {
        box: [
          'flex',
          'items-center',
          'justify-center',
          'rounded-full',
          'border',
          this.$style['box'],
          this.$style['box-size'],
          this.boxClass.box,
          {
            [this.$style['checked']]: this.state,
            'border-white': this.state,
            'border-grey-80': !this.state,
            'cursor-pointer': !this.disabled
          }
        ],
        circle: ['block', 'rounded-full', 'bg-white', this.$style['circle'], this.boxClass.circle]
      }
    }
  },

  watch: {
    state: function (newState) {
      this.$emit('change', { state: newState, value: this.value })
    }
  },

  methods: {
    toggle () {
      this.$emit('input', this.state ? '' : this.value)
    }
  }
}
</script>

<style lang="scss" module>
.vertical-box-align {
  vertical-align: -0.2em;
}

.box-size {
  min-width: 1em;
  min-height: 1em;
  width: 1em;
  height: 1em;
}

.box {
  vertical-align: -0.2em;
  user-select: none;
  transition: background 0.1s ease;

  .circle {
    opacity: 0;
    transform: scale(0);
    transition: transform 0.15s ease-in;
    will-change: transform;
  }

  &.checked > .circle {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
